const cartItemsTypes ={
    CART_ITEM_ADD: 'CART_ITEM_ADD',
    CART_ITEM_SUCCESS: 'CART_ITEM_SUCCESS',
    CART_ITEM_GET: 'CART_ITEM_GET',
    CART_ITEM_DELETE: 'CART_ITEM_DELETE',
    CART_ITEM_UPDATE: 'CART_ITEM_UPDATE',
    CART_ITEM_EMPTY: 'CART_ITEM_EMPTY',

    ORDER_LIST_GET: 'ORDER_LIST_GET',
    ORDER_LIST_SUCCESS: 'ORDER_LIST_SUCCESS',
    ORDER_LIST_UPDATE: 'ORDER_LIST_UPDATE',

}
export default cartItemsTypes;